import React, { useMemo } from "react";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";

export default function Pagination({
  page = 1,
  pageSize = 10,
  total = 0,
  totalPages: propTotalPages,
  onPageChange = () => {},
  onPageSizeChange = () => {},
}) {
  const totalPages = propTotalPages || Math.max(1, Math.ceil(total / pageSize));

  const pages = useMemo(() => {
 
    const maxButtons = 5;
    const res = [];
    const add = (x) => res.push(x);

    if (totalPages <= maxButtons + 2) {
      for (let i = 1; i <= totalPages; i++) add(i);
      return res;
    }

    const left = Math.max(2, page - 1);
    const right = Math.min(totalPages - 1, page + 1);

    add(1);
    if (left > 2) add("…");
    for (let i = left; i <= right; i++) add(i);
    if (right < totalPages - 1) add("…");
    add(totalPages);

    return res;
  }, [page, totalPages]);

  return (
    <div className="pager">
      <div className="pg-left">
        Showing
        <select
          className="pg-size"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {[10, 25, 50].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
        out of <b>{total}</b>
      </div>

      <div className="pg-right">
        <button
          className="pg-btn"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          aria-label="Previous page"
        >
          <LuChevronLeft size={16} />
        </button>

        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="pg-ellipsis">…</span>
          ) : (
            <button
              key={p}
              className={`pg-num ${p === page ? "is-active" : ""}`}
              onClick={() => onPageChange(p)}
              aria-current={p === page ? "page" : undefined}
            >
              {p}
            </button>
          )
        )}

        <button
          className="pg-btn"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          aria-label="Next page"
        >
          <LuChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
